interface FourPillarsChartProps {
  pillars: {
    year: { stem: string; branch: string; combined: string };
    month: { stem: string; branch: string; combined: string };
    day: { stem: string; branch: string; combined: string };
    hour: { stem: string; branch: string; combined: string };
  };
}

export default function FourPillarsChart({ pillars }: FourPillarsChartProps) {
  const pillarData = [
    {
      name: '年柱',
      subtitle: '년주',
      description: '조상·부모',
      pillar: pillars.year,
      gradient: 'from-blue-500/40 via-blue-600/30 to-blue-700/40',
      border: 'border-blue-400/60',
      textColor: 'text-blue-300',
      bgColor: 'bg-blue-500/20',
      shadowColor: 'shadow-blue-400/30',
      icon: 'ri-ancient-pavilion-line'
    },
    {
      name: '月柱',
      subtitle: '월주',
      description: '형제·직업',
      pillar: pillars.month,
      gradient: 'from-green-500/40 via-green-600/30 to-green-700/40',
      border: 'border-green-400/60',
      textColor: 'text-green-300',
      bgColor: 'bg-green-500/20',
      shadowColor: 'shadow-green-400/30',
      icon: 'ri-team-line'
    },
    {
      name: '日柱',
      subtitle: '일주',
      description: '본인·배우자',
      pillar: pillars.day,
      gradient: 'from-red-500/40 via-red-600/30 to-red-700/40',
      border: 'border-red-400/60',
      textColor: 'text-red-300',
      bgColor: 'bg-red-500/20',
      shadowColor: 'shadow-red-400/30',
      icon: 'ri-user-heart-line'
    },
    {
      name: '時柱',
      subtitle: '시주',
      description: '자녀·말년',
      pillar: pillars.hour,
      gradient: 'from-purple-500/40 via-purple-600/30 to-purple-700/40',
      border: 'border-purple-400/60',
      textColor: 'text-purple-300',
      bgColor: 'bg-purple-500/20',
      shadowColor: 'shadow-purple-400/30',
      icon: 'ri-parent-line'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
      {pillarData.map((item, index) => (
        <div
          key={index}
          className={`group relative backdrop-blur-xl bg-gradient-to-br ${item.gradient} rounded-3xl p-6 sm:p-7 border-2 ${item.border} overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl ${item.shadowColor}`}
        >
          {/* 배경 장식 패턴 */}
          <div className={`absolute top-0 right-0 w-32 h-32 ${item.bgColor} rounded-full blur-3xl opacity-50 group-hover:opacity-70 transition-opacity`}></div>
          <div className={`absolute bottom-0 left-0 w-24 h-24 ${item.bgColor} rounded-full blur-2xl opacity-30 group-hover:opacity-50 transition-opacity`}></div>
          
          {/* 장식 아이콘 */}
          <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity">
            <i className={`${item.icon} text-5xl text-white`}></i>
          </div>
          
          <div className="relative z-10">
            {/* 한자 제목 */}
            <div className="text-center mb-5">
              <p className={`text-2xl sm:text-3xl font-bold ${item.textColor} mb-2 tracking-wider group-hover:scale-110 transition-transform`}>{item.name}</p>
              <p className="text-sm text-white/70 font-medium">{item.subtitle}</p>
            </div>

            {/* 천간지지 - 크고 화려하게 */}
            <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-5 sm:p-6 mb-4 border border-white/20 group-hover:border-white/40 transition-all shadow-lg">
              <div className="flex justify-center items-center gap-3">
                <div className="text-center flex-1">
                  <p className="text-xs text-white/50 mb-2 font-medium">天干</p>
                  <p className="text-5xl sm:text-6xl font-bold text-white drop-shadow-lg group-hover:scale-110 transition-transform">{item.pillar.stem}</p>
                </div>
                <div className="w-0.5 h-20 bg-gradient-to-b from-transparent via-white/40 to-transparent"></div>
                <div className="text-center flex-1">
                  <p className="text-xs text-white/50 mb-2 font-medium">地支</p>
                  <p className="text-5xl sm:text-6xl font-bold text-white drop-shadow-lg group-hover:scale-110 transition-transform">{item.pillar.branch}</p>
                </div>
              </div>
            </div>

            {/* 설명 */}
            <div className="text-center">
              <p className="text-sm text-white/80 font-medium bg-white/10 rounded-full px-4 py-2 inline-block">{item.description}</p>
            </div>
          </div>

          {/* 호버 시 빛나는 효과 */}
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} blur-xl`}></div>
          </div>
        </div>
      ))}
    </div>
  );
}